import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  options: {customProperties: true},
  theme: {
    themes: {
      dark: {
        primary: '#0066CC',
        accent: '#d7aa02',
      },
      light: {
        primary: '#0066CC',
        accent: '#d7aa02',
      },
    },
  },
});
